import { render, staticRenderFns } from "./InsuranceTariffsList.vue?vue&type=template&id=1ed5846e&scoped=true"
import script from "./InsuranceTariffsList.vue?vue&type=script&lang=js"
export * from "./InsuranceTariffsList.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTariffsList.vue?vue&type=style&index=0&id=1ed5846e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5846e",
  null
  
)

export default component.exports